<template>
  <div class="bg">
    <div class="box">
      <div class="window">
        <div class="window-left">
          <div class="window-left-title">养老机构服务信用评价平台</div>
          <img class="window-left-img" src="../assets/login.png" />
        </div>
        <div class="window-right">
          <div class="window-right-title register-title">企 业 注 册</div>
          <el-input
            @keyup.enter.native="doRegister" class="login-input" v-model="companyName" :placeholder="companyNameRule" clearable/>
          <el-input
            @keyup.enter.native="doRegister" class="login-input" v-model="uscCode" :placeholder="uscCodeRule" clearable/>
          <el-select class="login-input" v-model="type" :placeholder="typeRule" clearable>
            <el-option v-for="(one, index) in options" :key="index" :label="one.label" :value="one.value" />
          </el-select>
          <el-input
            @keyup.enter.native="doRegister" class="login-input" v-model="username" :placeholder="usernameRule" />
          <el-input
            @keyup.enter.native="doRegister" class="login-input" v-model="password" :placeholder="passwordRule" show-password />
          <el-input
            @keyup.enter.native="doRegister" class="login-input" v-model="password2" :placeholder="password2Rule" show-password />
          <el-input
            @keyup.enter.native="doRegister" class="login-input" v-model="email" :placeholder="emailRule" />
          <el-input
            @keyup.enter.native="doRegister" class="login-input" v-model="nickName" :placeholder="nickNameRule" />
          <el-input
            @keyup.enter.native="doRegister" class="login-input" v-model="phone" :placeholder="phoneRule" />
          <div class="yzm" v-if="captchaEnabled">
            <el-input
              @keyup.enter.native="doRegister" class="login-input yzm-input" v-model="code" :placeholder="codeRule"></el-input>
            <img id="yzmimg" :src="yzmUrl" @click="getCode" alt="验证码">
          </div>
          <el-button class="login-btn" type="primary" @click="doRegister" :loading="loading">
            <span v-if="!loading">立即注册</span>
            <span v-else>注册中...</span></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCodeImg, register, repeat } from "@/api/login";

export default {
  name: 'Register',
  data() {
    return {
      companyName: "",
      uscCode: "",
      type: 1,
      username: "",
      password: "",
      password2: "",
      email: "",
      nickName: "",
      phone: "",
      code: "",
      loading: false,

      companyNameRule: "请输入企业名称",
      uscCodeRule: "请输入统一社会信用代码",
      typeRule: "请选择企业类型",
      usernameRule: "请输入用户名",
      passwordRule: "请输入密码",
      password2Rule: "请再次输入密码",
      emailRule: "请输入邮箱",
      nickNameRule: "请输入联系人",
      phoneRule: "请输入联系电话",
      codeRule: "请输入验证码",


      options: [
        {
          value: 1,
          label: "养老机构"
        }
      ],

      yzmUrl: "",
      uuid: "",
      captchaEnabled: "",

    }
  },
  watch: {},
  created() {
    this.getCode();
  },
  mounted() {},
  methods: {
    // 获取验证码
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.yzmUrl = "data:image/gif;base64," + res.img;
          this.uuid = res.uuid;
        }
      });
    },

    // 注册按钮
    doRegister() {
      // 非空校验
      if (!this.checkParams()) return
      // 重复校验
      repeat({key: "companyName", val: this.companyName}).then(res=>{
        repeat({key: "uscCode", val: this.uscCode}).then(res1=>{
          repeat({key: "username", val: this.username}).then(res2=>{
            this.doRegisterReal()
          })
        })
      })

    },
    doRegisterReal() {
      // 注册
      register({
        code: this.code,
        companyName: this.companyName,
        email: this.email,
        nickName: this.nickName,
        password: this.password,
        phone: this.phone,
        type: this.type,
        uscCode: this.uscCode,
        username: this.username,
        uuid: this.uuid,
      }).then(() => {
        this.$message.success("账号" + this.username + "注册成功！")
        this.$router.push("/login");
      }).catch(() => {
        this.loading = false;
        if (this.captchaEnabled) {
          this.getCode();
        }
      });
    },
    // 通过校验返回 true,否则返回 false
    checkParams() {
      if (!this.companyName) {
        this.$message.error(this.companyNameRule)
        return false
      }
      if (!this.uscCode) {
        this.$message.error(this.uscCodeRule)
        return false
      }
      if (!this.type) {
        this.$message.error(this.typeRule)
        return false
      }
      if (!this.username) {
        this.$message.error(this.usernameRule)
        return false
      }
      if (!this.password) {
        this.$message.error(this.passwordRule)
        return false
      }
      if (!this.password2) {
        this.$message.error(this.password2Rule)
        return false
      }
      if (this.password !== this.password2) {
        this.$message.error("两次输入的密码不一致")
        return false
      }
      // if (!this.email) {
      //   this.$message.error(this.emailRule)
      //   return false
      // }
      if (this.email && !this.rulerCheck('email', this.email)) {
        this.$message.error("邮件地址不正确")
        return false
      }
      if (!this.nickName) {
        this.$message.error(this.nickNameRule)
        return false
      }
      if (!this.phone) {
        this.$message.error(this.phoneRule)
        return false
      }
      if (!this.rulerCheck('phone', this.phone)) {
        this.$message.error("联系电话不正确")
        return false
      }
      if (!this.code) {
        this.$message.error(this.codeRule)
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
.register-title {
  margin: 20px auto 10px;
}
.el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Register.vue